import React,{useEffect,useState} from "react";
import axios from "axios";
const API=`${process.env.REACT_APP_BACKEND_URL}/api`;
export default function AdminNotificationCount(){
 const [count,setCount]=useState(0);
 useEffect(()=>{let active=true;const load=async()=>{try{const r=await axios.get(`${API}/admin/notifications/inbox?limit=1`,{withCredentials:true});if(active)setCount(r.data.unread||0)}catch{}};load();const t=setInterval(load,60000);return()=>{active=false;clearInterval(t)}},[]);
 return count>0?<span className="rounded-full bg-red-600 px-2 py-0.5 text-xs font-bold text-white" aria-label={`${count} unread notifications`}>{count}</span>:null;
}
